<template>
  <div class="uniform-guide">
    <section class="section-top">

      <div class="info-text" v-if="ready">
        <table>
          <thead>
            <tr>
              <th colspan="2">구분</th>
              <th>3XS</th>
              <th>2XS</th>
              <th>XS</th>
              <th>S</th>
              <th>M</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="4" class="th">상의</td>
              <td>총 기장</td>
              <td>57</td>
              <td>60</td>
              <td>63</td>
              <td>68</td>
              <td>70</td>
            </tr>
            <tr>
              <td>어깨 너비</td>
              <td>33</td>
              <td>35</td>
              <td>37</td>
              <td>39</td>
              <td>43</td>
            </tr>
            <tr>
              <td>가슴 너비</td>
              <td>39</td>
              <td>41.5</td>
              <td>44</td>
              <td>46.5</td>
              <td>49</td>
            </tr>
            <tr>
              <td>허리 너비</td>
              <td>38.5</td>
              <td>41</td>
              <td>43.5</td>
              <td>46</td>
              <td>48.5</td>
            </tr>
            <tr>
              <td rowspan="3" class="th">하의</td>
              <td>총 기장</td>
              <td>35</td>
              <td>37</td>
              <td>39</td>
              <td>41</td>
              <td>43</td>
            </tr>
            <tr>
              <td>허리 단면</td>
              <td>19</td>
              <td>21.5</td>
              <td>24</td>
              <td>26.5</td>
              <td>29</td>
            </tr>
            <tr>
              <td>엉덩이 단면</td>
              <td>40</td>
              <td>42.5</td>
              <td>45</td>
              <td>47.5</td>
              <td>50</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="content-empty">
        <PageComingSoon :titleText="' '" :descriptionText="String(readyMsg)" />
      </div>

    </section>
  </div>
</template>

<script>
import PageComingSoon from '@/components/Common/PageComingSoon.vue';
export default {
  name: 'UniformGuide',
  components: {PageComingSoon},
  data() {
    return {
      ready: true,
      readyMsg: '준비 중입니다'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.uniform-guide {
  text-align: center;
  padding: 50px 15px;
}
.info-text {
  padding: 0 20px 100px;
}
.info-text img {
  width: 100%;
  max-width: 300px;
}
table {
  width: 100%;
  margin: 0 auto;
  border-collapse: collapse;
}
table th, table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}
table th,
table td.th {
  font-weight: bold;
  background-color: #f2f2f2;
}
</style>